<template>
  <form-group title="Dados do integrador">
    <v-row>
      <v-col cols="6">
        <input-text
          id="input:nomIntegrador"
          v-model="payload.nomIntegrador"
          :rules="[requiredRule]"
          label="Nome do integrador"
          required
        />
      </v-col>
      <v-col cols="6">
        <input-select
          id="input:sglIntegrador"
          v-model="payload.sglIntegrador"
          :rules="[requiredRule]"
          :items="sglIntegradorOptions"
          label="Sigla"
          disabled
          required
        />
      </v-col>
    </v-row>
    <slot />
  </form-group>
</template>

<script>
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import IntegradorSgl from '@/app/arch/enums/IntegradorSgl';
import RulesMixin from '@/app/arch/mixins/RulesMixin';

export default {
  name: 'IntegradorContent',
  components: { FormGroup },
  mixins: [RulesMixin],
  props: {
    value: {
      type: Object,
      required: true,
      default() {
        return {
          nomIntegrador: '',
          sglIntegrador: '',
        };
      },
    },
  },
  data: () => ({
    sglIntegradorOptions: IntegradorSgl,
  }),
  computed: {
    payload() {
      return this.value;
    },
  },
};
</script>

<style>

</style>
